<template lang="pug">
.container.grid-lg.py-2
  .no-print
    filter-component

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      table.table.table-striped.table-sm
        thead
          tr
            th {{ "ordem_servico.numero" | tModel }}/{{ "ordem_servico.ano" | tModel }}
            th {{ "ordem_servico.assunto" | tModel }}
            th {{ "ordem_servico.cadastro" | tModel }}
            th {{ "ordem_servico.protocolo_tipo" | tModel }}
            th {{ "ordem_servico.protocolo_numero" | tModel }}
            th {{ "ordem_servico.created_at" | tModel }}
            th {{ "ordem_servico.situacao" | tModel }}
            th Fiscal
            th.actions-col.no-print
        tbody
          tr(v-for="osm in list", :key="osm.id")
            td {{ osm.numero }}/{{ osm.ano }}
            td {{ osm.assunto ? osm.assunto.descricao : "-" }}
            td(v-if="osm.cadastro")
              small
                span.abbr {{ osm.cadastro | enums("cadastro.tipo") }}&nbsp;
              span {{ osm.cadastro.numero }}
            td(v-else) -
            td {{ osm | enums("ordem_servico.protocolo_tipo") }}
            td {{ osm.protocolo_numero }}/{{ osm.protocolo_ano }}
            td {{ osm.created_at | date }}
            td {{ osm | enums("ordem_servico.situacao") }}
            td {{ osm.usuario_responsavel ? osm.usuario_responsavel.nome : "-" }}
            td.actions-col.no-print
              router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                data-tooltip="Exibir",
                :to="{ name: 'app.osm.servicos.show', params: { id: osm.id } }"
              )
                i.fa.fa-eye
        tfoot
          tr
            th Total
            th.text-right {{ count }}
            th(colspan="99")
      .my-2.text-right(v-if="pages > 1")
        btn-paginate(
          :page="page",
          :pages="pages",
          :count="count",
          @go-page="goPage",
          @prev-page="prevPage",
          @next-page="nextPage"
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FilterComponent from "./Filter"

export default {
  vuex: { servicos: vuexDefaultMapping },
  components: { FilterComponent },
  data() {
    return { q: {} }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
